<template>
  <div class="main">
    <!-- <img v-if="condition" src="../../assets/dongti/swimer.png"> -->
    <div
      class="tag"
      v-for="(row, index) in tag_list"
      :key="index"
      :class="{ warning: row.warning }"
      :style="{ top: row.y, left: row.x, zIndex: row.warning ? 100 : 99, display: show_type(row) }"
    >
      <img v-if="row.warning" src="../../assets/dongti/warn-icon.png" />
    </div>
    <img class="map" :src="options.map" />
  </div>
</template>

<script>
import mqtt from 'mqtt'
import { mapState } from 'vuex'

let client

export default {
	props: {
	  options: {
	    type: Object,
	    default() {
	      return {}
	    },
	  },
	},
  data() {
    return {
      tag_list: [],
      tags: [],
      width: 6092,
      height: 2996,
    }
  },
  computed: {
    ...mapState({
      sid: (state) => state.user.sid,
    }),
    show_type() {
      return (row) => {
        if (row.timstemp + 20000 < new Date().valueOf() && !row.warning) {
          return 'none'
        } else {
          return 'block'
        }
      }
    },
  },
  mounted() {
    // this.get_tags().then(() => {
    //   this.get_position()
    // })
  },
  beforeDestroy() {
    if (client) {
      client.end()
    }
  },
  methods: {
    warning(list) {
      this.tag_list.forEach((row) => {
        row.warning = false
      })
      list.forEach((data) => {
        const i = this.tag_list.findIndex((row) => {
          return row.tag === data.tag
        })
        const position = data.position.match(/\(([^)]*)\)/)[1].split(',')

        const x = Math.round((position[0] * 10000) / this.width) / 100
        const y = Math.round((position[1] * 10000) / this.height) / 100

        if (~i) {
          this.tag_list[i].x = x + '%'
          this.tag_list[i].y = y + '%'
          this.tag_list[i].warning = true
        } else {
          const obj = {
            x: x + '%',
            y: y + '%',
            tag: data.tag,
            warning: true,
            timstemp: new Date().getTime(),
          }
          this.tag_list.push(obj)
        }
      })
    },
    get_tags() {
      return this.$http({
        url: `stadium/online-tags`,
        method: 'get',
        params: {
          sid: this.sid,
          map_id: '4',
        },
      }).then((r) => {
        this.tags = r.data
      })
    },
    get_position() {
      const options = {
        clean: true, // 保留回话
        connectTimeout: 40000, // 超时时间
        rejectUnauthorized: false,
        // 认证信息
        clientId: 'Monitor' + new Date().valueOf(),
        username: 'com.zzdc.location.client',
        password: 'IsTKzpQwHWyAG5',
      }

      // const connectUrl = 'wss://192.168.8.100:18018/mqtt'
      // const connectUrl = 'ws://192.168.8.100:8083/mqtt'
      const connectUrl = 'ws://' + (process.env.VUE_APP_WS_HOST || window.location.host) + process.env.VUE_APP_WS_URL
      client = mqtt.connect(connectUrl, options)

      client.on('connect', (e) => {
        console.log('链接成功!!!', e)
        client.subscribe('mbkj/#', (err) => {
          if (!err) {
            // console.log(err, 111)
            // client.publish('presence', 'Hello mqtt')
          }
        })
      })

      client.on('reconnect', (error) => {
        console.log('正在重连:', error)
      })

      client.on('error', (error) => {
        console.log('连接失败:', error)
      })

      client.on('message', (topic, message) => {
        // console.log('收到消息：', topic, JSON.parse(message.toString()))
        const data = JSON.parse(message.toString())
        if (data.msgType === 'coord') {
          const x = Math.round((data.x * 10000) / this.width) / 100
          const y = Math.round((data.y * 10000) / this.height) / 100

          const i = this.tag_list.findIndex((row) => {
            return row.tag === data.code
          })

          if (~i) {
            this.tag_list[i].x = x + '%'
            this.tag_list[i].y = y + '%'
            this.tag_list[i].timstemp = new Date().getTime()
          } else {
            const j = this.tags.findIndex((row) => {
              return row === data.code
            })
            if (~j) {
              const obj = {
                x: x + '%',
                y: y + '%',
                tag: data.code,
                warning: false,
                timstemp: new Date().getTime(),
              }
              this.tag_list.push(obj)
            }
          }
        } else {
          if (data.msgType !== 'online') {
            console.log(data.msgType)
          }
        }
      })

      client.on('close', (e) => {
        console.log('关闭连接：', e)
      })
    },
  },
}
</script>

<style lang="less" scoped>
.main {
  position: relative;
  position: relative;
  .tag {
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #40fc79;
    top: 0%;
    left: 0%;
    transform: translate(-50%, -50%);
    transition: all 0.2s ease;
    &.warning {
      background: none;
      width: 28px;
      height: 28px;
      border-radius: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
      }
    }
  }
}
img.map {
  box-shadow: 0 0 0 6px rgb(29, 73, 114);
  width: 100%;
}
</style>
